const INTERIM_RESPONSES = [
  'Thinking this through…',
  'Working on a response…',
  'Putting the pieces together…',
  'Considering the question…',
  'Processing the details…',
  'Formulating an answer…',
  'Taking a moment to reflect…',
  'Organizing the explanation…',
  'Reasoning it out…',
  'Exploring the idea…',
  'Lining up the next steps…',
  'Making sense of it…',
  'Working through the logic…',
  'Shaping a clear explanation…',
  'Connecting the dots…',
  'Clarifying the approach…',
  'Refining the response…',
  'Weighing the details…',
  'Almost there…',
  'Finalizing the answer…',
];


const state = {
  contextType: null,
  assetId: null,
  assetType: null,
  conversationId: null,
  polling: false,
  interimResponse: '',
  previousContextType: null,
  previousAssetId: null,
  previousAssetType: null,
  previousConversationId: null,
};

const getters = {
  contextType: (state) => state.contextType,
  assetId: (state) => state.assetId,
  assetType: (state) => state.assetType,
  conversationId: (state) => state.conversationId,
  polling: (state) => state.polling,
  interimResponse: (state) => state.interimResponse,
  previousContextType: (state) => state.previousContextType,
  previousAssetId: (state) => state.previousAssetId,
  previousAssetType: (state) => state.previousAssetType,
  previousConversationId: (state) => state.previousConversationId,
};

const mutations = {
  setContextType(state, contextType) {
    state.contextType = contextType;
  },
  setAssetId(state, assetId) {
    assetId = Number(assetId);
    if (isNaN(assetId)) {
      assetId = null;
    }
    state.assetId = assetId;
  },
  setAssetType(state, assetType) {
    state.assetType = assetType;
  },
  setConversationId(state, conversationId) {
    state.conversationId = conversationId;
  },
  setPreviousConversationId(state, conversationId) {
    state.previousConversationId = conversationId;
  },
  setPolling(state, polling) {
    state.polling = polling;
  },
  setInterimResponse(state, generate = true) {
    if (generate) {
      const randomIndex = Math.floor(Math.random() * INTERIM_RESPONSES.length);
      state.interimResponse = INTERIM_RESPONSES[randomIndex];
    } else {
      state.interimResponse = '';
    }
  },
  cachePreviousContext(state) {
    state.previousContextType = state.contextType;
    state.previousAssetId = state.assetId;
    state.previousAssetType = state.assetType;
    state.previousConversationId = state.conversationId;
  },
  restorePreviousContext(state) {
    state.contextType = state.previousContextType;
    state.assetId = state.previousAssetId;
    state.assetType = state.previousAssetType;
    state.conversationId = state.previousConversationId;
  },
  startNewConversation(state) {
    state.contextType = state.previousContextType;
    state.assetId = state.previousAssetId;
    state.assetType = state.previousAssetType;
  },
};

const actions = {
  setContextType({ commit }, contextType) {
    commit('setContextType', contextType);
  },
  setAssetId({ commit }, assetId) {
    commit('setAssetId', assetId);
  },
  setAssetType({ commit }, assetType) {
    commit('setAssetType', assetType);
  },
  setConversationId({ commit }, conversationId) {
    commit('setConversationId', conversationId);
  },
  setPreviousConversationId({ commit }, conversationId) {
    commit('setPreviousConversationId', conversationId);
  },
  setPolling({ commit }, polling) {
    commit('setPolling', polling);
  },
  setInterimResponse({ commit }, generate) {
    commit('setInterimResponse', generate);
  },
  cachePreviousContext({ commit }) {
    commit('cachePreviousContext');
  },
  restorePreviousContext({ commit }) {
    commit('restorePreviousContext');
  },
  startNewConversation({ commit }) {
    commit('startNewConversation');
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
